/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "JShaikh",
  title: "Hi all, I'm JShaikh",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / Android and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1W504_sOJY6LKCv-co0rtlCORkO6OaqF3/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jelonmusk",
  linkedin: "https://www.linkedin.com/in/juvairiya-fathima/",
  gmail: "jelonmusk@gmail.com",
  gitlab: "https://www.youtube.com/channel/UCYKvkhU5vNS5O7W-J-zlp4g",
  facebook: "https://studentambassadors.microsoft.com/en-US/profile/69241",
  medium: "https://medium.com/@jelonmusk",
  stackoverflow: "https://stackoverflow.com/users/12005297/j-shaikh",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK AND LEVERAGE THEM TO SOLVE REAL-LIFE PROBLEMS.",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS /Azure"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "R L Jalappa Institute of Technology",
      logo: require("./assets/images/rljitLogo.png"),
      subHeader: "Bachelor of Engineering in Computer Science",
      duration: "August 2017 - August 2021",
      desc: "Participated in the research of Deep Learning Image Processing Networks.",
      descBullets: [
        "Institute Topper with a cgpa score of 9.33.",
        "Participated in the 2-Day Drone Developement Workshop organised by IIT-Roorkee-EduxLabs"
      ]
    },
    // {
    //   schoolName: "Stanford University",
    //   logo: require("./assets/images/stanfordLogo.png"),
    //   subHeader: "Bachelor of Science in Computer Science",
    //   duration: "September 2013 - April 2017",
    //   desc:
    //     "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
    //   descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "75%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Microsoft Learn Beta Student Ambassador",
      company: "Microsoft",
      companylogo: require("./assets/images/microsoftLogo.png"),
      date: "Jan 2020 – Present",
      desc:
        "Learn Student Ambassadors are a global group of campus leaders who are eager to help fellow students, create robust tech communities and develop technical and career skills for the future.",
      descBullets: [
        "Recognised for my contributions, passion and commitment to the program.",
        "Hosted events, workshops and hackathons about Microsoft technologies like Azure in communities and built a community of students on-campus and online."
      ]
    },
    {
      role: "Technical Content Writer Intern",
      company: "GeeksForGeeks",
      companylogo: require("./assets/images/gfgLogo.png"),
      date: "Dec 2020 – Present",
      desc:
        "Authored articles on technologies that include Version Control Software, Rust-lang, Python library functions, Analytics, JavaScript,Cybersecurity, Azure and AWS."
    },
    {
      role: "Software Engineer Intern",
      company: "POSibolt Solutions",
      companylogo: require("./assets/images/posiboltLogo.png"),
      date: "Oct 2020 – Dec 2020",
      descBullets:[
        "Worked on implementing different ERP modules and making them run successfully.",
        "Programmed parts of the ERP module that paved the way for Integration with other Systems"
    ]
    },
    
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME OTHER POSITIONS OF RESPONSIBLITIES",
  projects: [
    {
      image: require("./assets/images/turingLogo.png"),
      projectName: "Turing Club",
      projectDesc: "Founded campus coding club to help and improve student’s programming skills by spearheading a team of 4 members including event lead, UI/UX designer and developer and successfully organized various online events with 190+ reach from across India",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.instagram.com/turingclub_tc/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/slopLogo.jpg"),
      projectName: "Google DSC-SLoP Student Mentor",
      projectDesc: "Mentored students and provided real-life development projects to students to give them the opportunity to learn more about current tools and technologies.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://dsc-slop.github.io/"
        },
        //  you can add extra buttons here.
        {
          name: "See Certificate",
          url: "https://drive.google.com/drive/u/1/folders/108eoGGCww62QFy0gDN_otGK1q4K-OrxO"
        }
      ]
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Dell & Microsoft Study Buddy Program",
      subtitle:
        "Semi Finalist in Dell All India Contest at the age of 13.",
      image: require("./assets/images/dell.png"),
      footerLink: [
        {
          name: "Blog",
          url:
            "https://lxl.in/krayon/dell-study-buddy/"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action Python Quisss that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url:
            "https://www.youtube.com/watch?v=Skeu0G3PTro"
        },
      ]
    },
    {
      title: "TCS TECH BYTES Participant",
      subtitle:
        "A Statewide Engineering IT quiz (TCS TECH BYTES)organised by Tata Consultancy Services",
      image: require("./assets/images/tcs.png"),
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1daYP-BF7clzqJTN6sqp-2lrS2eIVi_ig/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://jelonmusk.medium.com/simple-weather-app-tutorial-explained-33554d624e3b",
      title: "Build a Simple Weather App",
      description:
        "Create a simple Weather App using just 3 files and an API."
    },
    {
      url: "https://medium.com/analytics-vidhya/converting-whatsapp-chat-data-into-a-word-cloud-python-simple-way-1f003b03f5f9",
      title: "Converting WhatsApp chat data into a Word Cloud | Python | Simple Way",
      description:
        "I was learning about pandas and its applications when I came across the word cloud module in python."
    },
    {
      url: "https://www.geeksforgeeks.org/difference-between-dalvik-and-art-in-android/",
      title: "Difference Between Dalvik and ART in Android",
      description:
        "ART is the managed runtime used by applications and some system services on Android. ART and its predecessor Dalvik were originally created specifically for the Android project."
    },
    {
      url: "https://www.geeksforgeeks.org/when-not-to-use-recursion-while-programming-in-python/",
      title: "When not to use Recursion while Programming in Python?",
      description:
        "To recurse or not to recurse, that is the question. We all know about the fun we have with recursive functions. But it has its own set of demerits too."
    },
    {
      url: "https://www.geeksforgeeks.org/technical-overview-of-microsoft-mesh/",
      title: "Technical Overview of Microsoft Mesh",
      description:
        "Mesh is Microsoft’s vision for the future of mixed reality. Mesh is a team platform that allows you to have shared virtual experiences on a variety of devices which was launched on March 2, 2021, during the Microsoft Ignite 2021 event."
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Demos",
  subtitle: emoji(
    "CHECKOUT VIDEO DEMONSTRATIONS OF FEW OF MY PROJECTS."
  ),

  talks: [
    {
      title: "JShaikh's Channel",
      subtitle: "See Video Demos",
      event_url: "https://www.youtube.com/channel/UCYKvkhU5vNS5O7W-J-zlp4g"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "jelonmusk@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
